import { useApiClientBase } from "./apiClient";

/**
 * usefileUploadApi is a custom hook that provides API functions
 * for uploading images and fetching master data details from the backend.
 * It uses the configured API client and error handler from useApiClientBase.
 *
 * @returns { uploadImage, getMasterDataDetails } - Functions to upload images and fetch master data details.
 */
export const usefileUploadApi = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { apiClient, handleError } = useApiClientBase();

  /**
   * Uploads an image to the backend API.
   *
   * @param formdata - The FormData object containing the image file to upload.
   * @param params - Additional parameters, such as the folder path for upload.
   * @returns {Promise<any>} - The response data from the API, or null if an error occurs.
   */
  const uploadImage = async (formdata: FormData, params: any) => {
    try {
      const response = await apiClient.post(
        `/Upload/upload?folderPath=${params.folderpath}`,
        formdata,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (err) {
      // handleError is your custom error handler
      return handleError(err, "uploading image");
    }
  };

  /**
   * Fetches the dropdown details of the master data from the backend API.
   *
   * @returns {Promise<any>} - The response data containing master data details, or null if an error occurs.
   */
  const getMasterDataDetails = async () => {
    try {
      const response = await apiClient.get("/Upload/getblobstoragedetails");
      return response.data;
    } catch (err) {
      return handleError(err, "fetching review scenario values");
    }
  };

  return { uploadImage, getMasterDataDetails };
};
